export const modalData = {
  title: {
    en: 'Admission Open!!',
    np: 'भर्ना खुल्यो !!',
  },
  subtitle: {
    en: 'Admission open for Diploma in Civil Engineering and Diploma in Agriculture (Plant Science).',
    np: 'डिप्लोमा इन सिभिल इन्जिनियरिङ र डिप्लोमा इन एग्रीकल्चर (वनस्पति विज्ञान) का लागि भर्ना खुल्यो ।',
  },
  buttonText: {
    en: 'Register',
    np: 'दर्ता गर्नुहोस्',
  },
};
